import theme from "@monorepo/styles/theme";
import { CartStatusesEnum } from "@monorepo/types";
import { SvgIcon, SvgIconProps } from "@mui/material";

import { ServiceIconsSizeEnum } from "../ServiceIcons";

const StyledSvgIcon = (
  props: SvgIconProps & {
    active: boolean;
    activeColor: string;
    usesFill?: boolean;
    delayed?: boolean;
    statusId?: CartStatusesEnum;
    size?: ServiceIconsSizeEnum;
  }
) => {
  const { active, activeColor, usesFill, delayed, statusId, size, ...other } = props;
  const paidNotDelayed = !delayed && statusId === CartStatusesEnum.PAID;

  return (
    <SvgIcon
      sx={{
        background: paidNotDelayed
          ? theme.palette.background.paper
          : active
          ? activeColor
          : theme.palette.background.paper,
        border: paidNotDelayed
          ? `solid 1px ${theme.palette.primary.main}`
          : active
          ? `solid 1px ${activeColor}`
          : `solid 1px ${theme.palette.gullGray.main}`,
        "& path": {
          stroke: paidNotDelayed ? theme.palette.primary.main : !active ? theme.palette.gullGray.main : "auto",
          fill: !active && usesFill ? theme.palette.gullGray.main : "auto",
        },
        borderRadius: "50%",
        verticalAlign: "middle",
        ...(size === "large" && {
          padding: theme.spacing(4 / 5),
        }),
        ...(size === "small" && {
          padding: theme.spacing(4 / 8),
        }),
      }}
      fontSize={size}
      {...other}
      viewBox={props.viewBox}
    />
  );
};
export default StyledSvgIcon;
